export const DomainNamespace_ShortUrl = 'short-url';
export const PermissionKey_ShortUrlView = 'permission-key--short-url-view';
export const PermissionKey_ShortUrlEdit = 'permission-key--short-url-edit';
//# sourceMappingURL=consts.js.map